import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';
import {loadStripe} from '@stripe/stripe-js/pure';
import {AngularFireFunctions} from '@angular/fire/functions';
import {LiveEvent, LiveEventAdapter} from '../../models/live-event/live-event';
import * as moment from 'moment';
import {ContentfulService} from '../../services/contentful.service';
import {AngularFireDatabase} from '@angular/fire/database';
import {take} from 'rxjs/operators';
const stripePromise = loadStripe('pk_live_Alk04fb7KAp2n3KW359tLAuI');

@Component({
  selector: 'app-device-register',
  templateUrl: './device-register.component.html',
  styleUrls: ['./device-register.component.scss']
})
export class DeviceRegisterComponent implements OnInit {
  stripeFunction: any;
  registerDeviceFunction: any;
  stripeSessionId: any;
  accessCode: string;
  userId: string;
  password: string;
  showErrorMessage: boolean;
  showPaywall = true;
  errorMessage = 'We don\'t recognize this information. Check your credentials!';
  error = false;
  video: LiveEvent;
  showSuccess;
  purchases;
  liveEntryId = '2F3wTjs5NkTz9XvuMeQZXT';
  constructor(public auth: AngularFireAuth, private db: AngularFireDatabase, private router: Router, private firebaseAuth: AngularFireAuth,  private fns: AngularFireFunctions, private contentfulService: ContentfulService) {
    this.stripeFunction = fns.httpsCallable('stripe-createStripeSession');
    this.registerDeviceFunction = fns.httpsCallable('roku-registerDevice');
  }

  ngOnInit() {
    this.firebaseAuth.authState.pipe(take(1)).subscribe(auth => {
      if (auth) {
        this.userId = auth.uid;
        this.purchases = this.db.list(`users/${this.userId}/purchases`).valueChanges().subscribe((res: any) => {
          const match = res.filter((purchase) => purchase.entryId === this.liveEntryId);
          this.contentfulService.getEntry(this.liveEntryId).then((res) => {
            this.video = new LiveEventAdapter().creatLiveEventFromEntry(res);
            const d = new Date(this.video.startTime);
            const diff = moment().diff(d, 'days');
            if (diff > 0) {
              // this.router.navigate(['']);
              this.showPaywall = false;
            } else if (match.length || this.contentfulService.allAccess || this.video.planPrice === 0) {
              this.showPaywall = false;
            } else {
              this.showPaywall = true;
            }
          });
        });
      } else {
        this.showPaywall = true;
      }
    });
  }

  registerDevice() {
    this.registerDeviceFunction({accessCode: this.accessCode}).subscribe(async (res) => {
      if (res.result === 'error') {
        this.showErrorMessage = true;
        this.errorMessage = res.message;
      } else if (res.result === 'success') {
        this.showSuccess = true;
      }
    });
  }

  goToStripeCheckout() {
    this.stripeFunction({ entryId: this.liveEntryId, planId: this.video.planId, eventTitle: this.video.title, recurring: true, successUrl: `https://app.wosn.tv/device-register`, cancelUrl: `https://app.wosn.tv/device-register`}).subscribe(async (res) => {
      const stripe = await stripePromise;
      this.stripeSessionId = res.session.id;
      return stripe.redirectToCheckout({
        sessionId: res.session.id
      })
        .then((result) => {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
          console.error('ERR', result.error);
          if (result.error) {
            this.error = true;
            this.errorMessage = 'There was an error launching checkout with this device, please try again. If this issue continues, try a different device.';
          }
        });
    });
  }

  async launchStripeCheckout() {
    const stripe = await stripePromise;
    return stripe.redirectToCheckout({
      sessionId: this.stripeSessionId
    });
  }

}
